import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
const included = ['📚 6 Tomes Premium Illustrés', '🎁 5 Bonus Exclusifs OFFERTS', '🃏 84 Cartes de Phrases de Guérison', '🖨️ Ressources Imprimables Premium', '🗺️ Schémas & Génogrammes Systémiques', '🧘 10 Méditations + Journal 30 Jours'];
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-10 sm:py-12" data-id="element-159" data-mp="1t3emxf5a681a">
      <Reveal className="mx-auto max-w-[520px]" data-id="element-160" data-mp="1t3xuq317vg1l">
        <div id="collection-complete" className="scroll-mt-4 overflow-hidden rounded-2xl border border-amber/50 bg-surface shadow-elevated" data-id="element-161" data-mp="1y2982nqq08ok">
          <div className="border-b border-amber/40 bg-amber-pale px-4 py-2.5 text-center text-[13px] font-bold leading-snug text-navy" data-id="element-162" data-mp="1k52ows2347yt">
            🧘 Package complet · Tout inclus · Sans abonnement
          </div>
          <div className="px-5 py-6 sm:px-7 sm:py-7" data-id="element-163" data-mp="cp6eeohchz8n">
            <h2 className="text-center font-serif text-2xl leading-tight text-navy sm:text-3xl" data-id="element-164" data-mp="cqpvghatsebh">
              Système des Constellations Familiales™
            </h2>

            <p className="mt-4 text-center text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-165" data-mp="cx7auj4l98o8">
              📦 Tout ce que vous recevez
            </p>
            <ul className="mx-auto mt-3 max-w-sm space-y-1.5 text-[15px] leading-6 text-slate" data-id="element-166" data-mp="qtu8ko4d82v7">
              {included.map(item => <li key={item} data-id="element-167" data-mp="10tl48t4nwnwv">{item}</li>)}
            </ul>

            <div className="mt-5 border-t border-navy/10 pt-4 text-center" data-id="element-168" data-mp="vv9tmg6jm9dl">
              <p className="text-sm font-bold text-navy" data-id="element-169" data-mp="vt5ra2oaliff">
                Valeur totale : <span className="line-through" data-id="element-170" data-mp="1ajmsbkx0m6bs">94 EUR</span>
              </p>
              <span className="mt-2 inline-block rounded-full bg-[#F4B400] px-5 py-2 text-sm font-extrabold uppercase tracking-[0.06em] text-navy" data-id="element-171" data-mp="15ktgdwxdmndq">
                Vous économisez 75 EUR
              </span>

              <div className="mt-3 font-serif text-7xl leading-none text-navy" data-id="element-172" data-mp="1emszcuryc1jb">
                19<span className="ml-1 align-super font-sans text-xl font-bold" data-id="element-173" data-mp="c94s26o0gzuu">EUR</span>
              </div>
              <p className="mt-2 text-sm text-slate" data-id="element-174" data-mp="h8hqloo8vvd9">Paiement unique · Sans frais cachés</p>

              <div className="mt-4" data-id="element-175" data-mp="l8rsap507zmb">
                <CTAButton href="https://systeme-des-constellations-familiales.impultienda.ar/checkout" pulse size="large" data-id="element-176" data-mp="l7qjysfdhr8a">
                  ⚡ ACCÈS INSTANTANÉ
                </CTAButton>
              </div>
              <p className="mt-3 text-xs leading-5 text-slate" data-id="element-177" data-mp="v0xjhwnfmd0g">
                🔒 Paiement sécurisé · 💳 Carte bancaire · ⚡ Accès immédiat · ∞ Accès à vie
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}